/*
 * @providesModule ProgressiveLeaguesConstants
 */

import {_m} from 'INTL';

export const PAID_LEAGUE_FAQ_LINK =
  'https://support.skillz.com/hc/en-us/articles/38947220469012-All-Star-Leagues';

export const GLOBAL_LEAGUES_FAQ_LINK =
  'https://support.skillz.com/hc/en-us/articles/41145081425684-Ultimate-Leagues';

export type PaidLeagueOptInModalFlow = 'LAUNCH' | 'LEAGUES_TAB';

//#region Storage constants for the automatic prompt of the paid league opt in modal
export const PAID_LEAGUE_OPT_IN_MODAL_CURRENT_LEAGUE_ID_LAUNCH =
  'paidLeagueOptInModalCurrentLeagueIdLaunch';
export const PAID_LEAGUE_OPT_IN_MODAL_CURRENT_LEAGUE_ID_LEAGUES_TAB =
  'paidLeagueOptInModalCurrentLeagueIdLeaguesTab';
export const PAID_LEAGUE_OPT_IN_MODAL_LAST_PROMPT_TIMESTAMP_LAUNCH =
  'paidLeagueOptInModalLastPromptTimestampLaunch';
export const PAID_LEAGUE_OPT_IN_MODAL_LAST_PROMPT_TIMESTAMP_LEAGUES_TAB =
  'paidLeagueOptInModalLastPromptTimestampLeaguesTab';
export const PAID_LEAGUE_OPT_IN_MODAL_PROMPT_COUNT_SEASON_LAUNCH =
  'paidLeagueOptInModalPromptCountSeasonLaunch';
export const PAID_LEAGUE_OPT_IN_MODAL_PROMPT_COUNT_SEASON_LEAGUES_TAB =
  'paidLeagueOptInModalPromptCountSeasonLeaguesTab';
//#endregion Storage constants for the automatic prompt of the paid league opt in modal

export const PAID_LEAGUE_OPT_IN_CUTOFF_TIME_TEXT = _m(
  'You just missed out! Registrations are closed for this league'
);

/**
 * The number of players that can be on the podium for a progressive league.
 * This is used to show the podium in the league results screen for Manual Claim.
 * This is not used for Auto Claim.
 */
export const PROGRESSIVE_LEAGUE_PODIUM_LIMIT_NUM_PLAYERS = 3 as const;

//#region Info modal view indices
export const INFO_MODAL_VIEW_INDEX_INTRO = 0;
export const INFO_MODAL_VIEW_INDEX_GAMES = 1;
//#endregion Info modal view indices
